import FlexBox from '@/atomic-components/FlexBox';
import DeliveryTruckIcon from '../../../../assets/pdp/deliveryIcon.svg';
import ThumbsUpIcon from '../../../../assets/pdp/thumbsUp.svg';
import PiggyBagIcon from '../../../../assets/pdp/piggyBagIcon.svg';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
import RightArrowIconWithMintyColor from '../../../../assets/pdp/rightArrowIconWithMintyColor.svg';

type ConditionsAndInfoProps = {
	text: string;
	description?: string;
	linkText?: string;
	icon: any;
	handleClick?: any;
};
type IconMapper = {
	deliveryTruck: any;
	condition: any;
	savings: any;
};

const iconMapper: IconMapper = {
	deliveryTruck: <DeliveryTruckIcon />,
	condition: <ThumbsUpIcon />,
	savings: <PiggyBagIcon />,
};

const ConditionsAndInfo = (props: ConditionsAndInfoProps) => {
	const { text, description, linkText, icon } = props;

	const textColor = text == 'OUT OF STOCK' ? 'Danger -2' : 'Gray -2';

	return (
		<FlexBox
			sx={{
				justifyContent: 'space-between',
				width: '100%',
				marginBottom: '24px',
			}}
		>
			<FlexBox>
				<Box>
					{iconMapper[icon as keyof IconMapper]
						? iconMapper[icon as keyof IconMapper]
						: ''}
				</Box>

				<LencoTypography
					sx={{
						...getStyle('Small_Medium'),
						color: getColor(`${textColor}`),
						paddingLeft: '8px',
					}}
				>
					{text}
					<LencoTypography
						component='span'
						sx={{
							...getStyle('Small_SemiBold'),
							color: getColor('Gray -2'),
							wordWrap: 'normal',
						}}
					>
						&nbsp;{description}
					</LencoTypography>
				</LencoTypography>
			</FlexBox>

			<FlexBox
				sx={{
					flexWrap: 'nowrap',
					cursor: 'pointer',
				}}
				onClick={props.handleClick}
			>
				<LencoTypography
					sx={{
						...getStyle('Small_Medium'),
						textDecoration: 'underline',
						whiteSpace: 'nowrap',
						color: getColor('Minty +1'),
						transition: 'font 0.5s',
						'&:hover': {
							...getStyle('P_SemiBold'),
						},
					}}
				>
					{linkText}
				</LencoTypography>
				<Box sx={{ paddingLeft: '4px' }}>
					<RightArrowIconWithMintyColor />
				</Box>
			</FlexBox>
		</FlexBox>
	);
};

export default ConditionsAndInfo;
